import { useCallback } from 'react';

import { Button } from '@twilio-paste/core/button';
import { useParams } from 'react-router';

import { Can } from '../../components/common/AbilityContext';
import { useDrawer } from '../../components/common/Drawer';
import { PageComponent } from '../../components/common/PageComponent';
import { TargetsTable, TargetsTableContextProvider } from '../../components/Targets/TargetsTable';
import { Action, Subject } from '../../modules/Permissions';

export function TargetsPage() {
  const { appId = '' } = useParams();
  const createTargetDrawerState = useDrawer();
  const editTargetDrawerState = useDrawer();
  const viewTargetDrawerState = useDrawer();
  const openDrawer = useCallback(() => createTargetDrawerState.show(), [createTargetDrawerState]);

  return (
    <PageComponent
      pageTitle="Targets"
      actions={
        <Can I={Action.Create} a={Subject.Target}>
          <Button variant="primary" onClick={openDrawer}>
            New Target
          </Button>
        </Can>
      }
    >
      <TargetsTableContextProvider
        createTargetDrawerState={createTargetDrawerState}
        editTargetDrawerState={editTargetDrawerState}
        viewTargetDrawerState={viewTargetDrawerState}
      >
        <TargetsTable appId={appId} />
      </TargetsTableContextProvider>
    </PageComponent>
  );
}
